<template>
  <el-dialog :visible="show" :title="row ? '编辑素材' : '新增素材'" width="600px" append-to-body @close="closeDialog">
    <el-form label-width="100px" ref="vForm" :model="vForm" size="medium">
      <el-form-item label="素材名称" prop="name" :rules="{ required: true, message: '素材名称必填' }">
        <el-input v-model="vForm.name"></el-input>
      </el-form-item>
      <el-form-item label="全景图片" prop="key" :rules="{ required: true, message: '全景图片必填' }">
        <div class="image-box">
          <v-upload-image v-model="image" width="200" height="100" max-size="1024*100" @change="changeImage" />
          <div v-if="row" class="image-box-mask"></div>
        </div>
        <div class="v-form-tips">
          请上传2:1的全景图片，例如：宽6000px，高3000px
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['show', 'row'],

  data() {
    return {
      doSubmitLoading: false,
      loading: false,
      city_id: this.$store.getters.userInfo.city_id,
      category: [],
      areaList: [],
      areaLoading: false,
      vForm: {
        name: '',
        key: '',
      },
      image: [],
    };
  },

  created() {
    if (this.row) {
      this.vForm.name = this.row.name;
      this.vForm.key = this.row.key;
      this.image = [{ key: this.row.key, preview: this.row.key_preview }];
    }
  },

  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },

    changeImage(images) {
      if (images.length) {
        if (images[0].key) {
          this.vForm.key = images[0].key;
          this.$refs.vForm.validateField('key');
        }
      } else {
        this.vForm.key = '';
        this.$refs.vForm.validateField('key');
      }
    },

    //提交作品
    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.$refs.vForm.validate();
        if (this.row) {
          await this.api.material.update({
            field_data: { name: this.vForm.name },
            id: this.row.id,
          });
        } else {
          await this.api.material.addMaterial({ keys: [this.vForm] });
        }
        this.$message.success(this.row ? '更新成功' : '新增成功');
        this.$emit('success');
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>

<style scoped>
.image-box {
  position: relative;
  width: 200px;
  height: 100px;
}
.image-box-mask {
  position: absolute;
  left: -1px;
  top: -1px;
  bottom: -1px;
  right: -1px;
  background: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
}
</style>
